export const MoonIcon = ({ color = '#535862' }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 5.9035C5.37077 5.27421 4.94225 4.47249 4.76861 3.59969C4.59498 2.72689 4.68403 1.8222 5.0245 1C4.05411 1.19097 3.16276 1.66711 2.4645 2.3675C0.511997 4.32 0.511997 7.486 2.4645 9.4385C4.4175 11.3915 7.583 11.391 9.536 9.4385C10.2361 8.74019 10.7121 7.84911 10.9035 6.879C10.0813 7.21947 9.17661 7.30852 8.30381 7.13488C7.43101 6.96125 6.62928 6.53273 6 5.9035Z"
        fill={color}
      />
    </svg>
  );
};
